import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const skillMapLines = api(async function skillMapLines({ skillMapId }) {
    return query(
        gql`
            query GetSkillMapLines($skillMapId: String!) {
                skillMapLines(skillMapId: $skillMapId) {
                    id
                    skillMapId
                    skillId
                    skillName
                    skillCode
                    isCustomSkill
                    customHourlyRate
                    tradeId
                    taskCount
                    conditionalTrades {
                        id
                        name
                        conditions {
                            field
                            operator
                            value
                        }
                        combinator
                        tradeId
                        sortOrder
                    }
                }
            }
        `,
        { skillMapId },
        { returns: "skillMapLines" }
    )
})
